import useMutateApi from '@hooks/useMutateApi';
import type {PropsWithChildren} from 'react';
import {useRef} from 'react';

import {createBackgroundTasksStore} from './store';
import type {BackgroundTasksStoreApi} from './types';
import {BackgroundTasksContext} from './useBackgroundTasks';

export const BackgroundTasksProvider = (props: PropsWithChildren) => {
  const {children} = props;
  const {trigger: subscribe} = useMutateApi(`publicSubscribeToBackgroundTask`);

  const subscribeFn = async (taskId: string) => {
    const subscription = subscribe({task_id: taskId});
    return subscription;
  };

  const storeRef = useRef<BackgroundTasksStoreApi>(createBackgroundTasksStore({subscribe: subscribeFn}));

  return <BackgroundTasksContext.Provider value={storeRef.current}>{children}</BackgroundTasksContext.Provider>;
};
